/* ============================================================
   GARD — Sepet Drawer Eklentileri JS (Vessel / Horizon uyumlu)
   - Upsell "Sete Tamamla" butonu: üünü ekler, tema morph'unu tetikler
   - Sayaç: sessionStorage'da saklanır, morph/sayfa geçişinde sıfırlanmaz
   Event delegation + global guard sayesinde morph sonrası bozulmaz.
   ============================================================= */
(function () {
  if (window.__gardCartExtras) return;
  window.__gardCartExtras = true;

  /* --- Upsell ekle (delegasyon: buton morph'la değişse de çalışır) --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-gard-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute('disabled')) return;

    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;

    var original = btn.innerHTML;
    btn.setAttribute('disabled', '');
    btn.textContent = btn.getAttribute('data-adding-label') || 'Ekleniyor…';

    var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url)
      ? Theme.routes.cart_add_url
      : '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        return r.json();
      })
      .then(function () {
        // Tema bu event'i dinler ve etkilenen section'ı kendisi morph eder.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: {} }
        }));
      })
      .catch(function () {
        btn.removeAttribute('disabled');
        btn.innerHTML = original;
        alert(btn.getAttribute('data-error-label') || 'Bir sorun oluştu, tekrar dene.');
      });
  });

  /* --- Geri sayım --- */
  var KEY = 'gard_cart_deadline';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var els = document.querySelectorAll('[data-gard-countdown]');
    if (!els.length) return;

    var now = Date.now();
    var deadline = parseInt(sessionStorage.getItem(KEY), 10);

    if (!deadline || isNaN(deadline) || deadline < now) {
      var mins = parseInt(els[0].getAttribute('data-gard-minutes'), 10) || 15;
      deadline = now + mins * 60 * 1000;
      sessionStorage.setItem(KEY, String(deadline));
    }

    var diff = Math.max(0, Math.floor((deadline - now) / 1000));
    var text = pad(Math.floor(diff / 60)) + ':' + pad(diff % 60);

    els.forEach(function (el) { el.textContent = text; });
  }

  setInterval(tick, 1000);
  tick();
  // Sepet güncellenince (morph sonrası) sayaç metnini hemen tazele
  document.addEventListener('cart:update', function () { setTimeout(tick, 50); });
})();
